import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { creditPackAsMemberQueryKeys } from "./creditPackAsMemberQueryKeys";

export const useInfiniteQuerySessionPackSubscriptionPreviousAsMember = ({
  api,
  enabled,
}: {
  api: ApiType;
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey:
      creditPackAsMemberQueryKeys.sessionPackSubscriptionPreviousAsMember(),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.customerCreditPackApi.sessionPackSubscriptionPrevious({
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    enabled,
    initialPageParam: undefined,
  });
